import { Base, createApp } from '@studiometa/js-toolkit';
import Facets from './organisms/Facets/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Facets,
    },
  };
}

export default createApp(App, document.body);
